import React from "react";
import { Modal } from "react-bootstrap";
import { Wrench } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

import { CustomDisclaimerModalProps } from "./CustomDisclaimerModal.types.tsx";

import { GreenLabel, HeaderLabel, ProjectDetailsLabel } from "../../components/Labels.tsx";
import { ActionButton } from "../../components/Buttons.tsx";

const CustomDisclaimerModal: React.FC<CustomDisclaimerModalProps> = ({
  show,
  handleClose,
  handleAccept,
  disclaimerText,
}) => {
  const { t } = useTranslation();

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static" keyboard={false}>
      <Modal.Body className="p-4 d-flex flex-column align-items-center text-center">
        <Wrench className="mb-3" size={30} />

        <HeaderLabel>{t("customDisclaimerModal.title")}</HeaderLabel>

        <ProjectDetailsLabel textAlign="center">{disclaimerText}</ProjectDetailsLabel>

        <div className="d-flex justify-content-evenly w-100 mt-3 buttonsContainer">
          <GreenLabel margin="0" onClick={handleClose}>
            {t("customDisclaimerModal.cancel")}
          </GreenLabel>

          <ActionButton width="30%" onClick={handleAccept}>
            {t("customDisclaimerModal.accept")}
          </ActionButton>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CustomDisclaimerModal;
